import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { ButtonToolbar, DropdownButton,Dropdown } from 'react-bootstrap'
import Radium from 'radium'

const FixedHeader: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  backgroundColor: '#fff',
  zIndex: 2,
  borderBottom: '1px solid #e9e6e6',
}

const InnerContainer: React.CSSProperties = {
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem',
  display: 'flex',
  alignItems: 'center',
  height: '75px',
}

const logoTxt: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
  cursor: 'pointer',
}

const imgStyles: React.CSSProperties = {
  width: '75px',
  height: '75px',
}

const txt: React.CSSProperties = {
  fontFamily: 'AveriaSerifLightItalic',
  marginLeft: '20px',
}

const navBar: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  flexGrow: 2,
}

const navItemStyle: React.CSSProperties = {
  fontFamily: 'BarlowMedium',
  margin: '0 20px',
  cursor: 'pointer',
  color: '#3a54b4',
  ':hover': { color: '#c2b186' },
}

const rightNav: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}

const topNavButton: React.CSSProperties = {
  width: '131px',
  height: '40px',
  backgroundColor: '#3a54b4',
  margin: '0 10px',
  lineHeight: '38px',
  padding: '5px',
  fontFamily: 'BarlowMedium',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
}

const topLoginStyle: React.CSSProperties = {
  ...topNavButton,
  margin: '0 10px',
}

const usernameStyle: React.CSSProperties = {
  fontFamily: 'BarlowLight',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

const mobileNav: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
}

const hamburger: React.CSSProperties = {
  backgroundImage: 'url(' + Tgcc.ResolveUrl('~/images/hamburger_2.png') + ')',
  height: '50px',
  width: '50px',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
}

const imgFile = Tgcc.ResolveUrl('~/images/2022Logo.png')

class _CatalogHeader extends React.Component<Tgcc.BaseProps> {
  openDesign = () => {
    browserHistory.push(Tgcc.Routes.CatalogDesignListView)
  }
  openRegister = () => {
    browserHistory.push(Tgcc.Routes.CampusRegister)
  }
  openDashboard = () => {
    const division = localStorage.getItem('division');
  
    switch (division) {
      case 'campus':
        browserHistory.push(Tgcc.Routes.CampusDashboard);
        break;
      case 'indigo':
        browserHistory.push(Tgcc.Routes.IndigoDashboard);
        break;
      case 'majoraccounts':
      default:
        browserHistory.push(Tgcc.Routes.DashBoard);
        break;
    }
  }
  
  openCatalog = () => {
    browserHistory.push(Tgcc.Routes.Catalog)
  }
  loginUser = () => {
    browserHistory.push(Tgcc.Routes.CampusLogin)
  }
  logoutUser = () => {
    Tgcc.LogoutCampusUser(this.props.dispatch, this.props.state.LoginData)
    this.props.dispatch({
      type: Tgcc.StateAction.ForwardLocation,
      payload: this.props.state.ActiveProof,
    })
    this.props.dispatch({
      type: Tgcc.StateAction.ForwardLocation,
      payload: this.props.state.ActiveProof,
    })
  }

  getLoginLink() {
    if (this.props.state.LoginData) {
      return (
        <div style={topLoginStyle} onClick={this.logoutUser}>
          Logout
        </div>
      )
    }
    return (
      <div style={topLoginStyle} onClick={this.loginUser}>
        Login
      </div>
    )
  }

  getDashboardLink() {
    if (!this.props.state.LoginData) {
      return (
        <div style={topNavButton} onClick={this.openRegister}>
          Create Account
        </div>
      )
    }
    return (
      <div style={topNavButton} onClick={this.openDashboard}>
        Dashboard
      </div>
    )
  }

  getUserName() {
    if (this.props.state.LoginData?.impersonate) {
      return (
        <div style={usernameStyle}>
          Impersonating: {this.props.state.LoginData.impersonate}
        </div>
      )
    }
    if (this.props.state.UserInfo?.email) {
      return (
        <div style={usernameStyle}>
          Logged in as: <strong>{this.props.state.UserInfo.email}</strong>
        </div>
      )
    }
    return null
  }

  renderMobileNav() {
    return (
      <div style={mobileNav}>
        <ButtonToolbar>
          <DropdownButton
            style={hamburger}
            
            title=""
            id="dropdown-no-caret"
          >
            <Dropdown.Item eventKey="102" onClick={this.openDesign}>
              DESIGNS
            </Dropdown.Item>
            <Dropdown.Item eventKey="103" onClick={this.openCatalog}>
              CATALOG REQUEST
            </Dropdown.Item>
          </DropdownButton>
        </ButtonToolbar>
        {this.getLoginLink()}
        {this.getDashboardLink()}
        {this.getUserName()}
      </div>
    )
  }

  renderDesktopNav() {
    return (
      <>
        <div style={logoTxt} onClick={this.openCatalog}>
          <img src={imgFile} style={imgStyles} alt="TGCC Logo" />
          <span style={txt}>TGCC Campus</span>
        </div>

        <div style={navBar}>
          <div
            key="nav-designs"
            style={navItemStyle}
            onClick={this.openDesign}
          >
            DESIGNS
          </div>
          <div
            key="nav-catalog"
            style={navItemStyle}
            onClick={this.openCatalog}
          >
            CATALOG
          </div>
        </div>

        <div style={rightNav}>
          {this.getLoginLink()}
          {this.getDashboardLink()}
          {this.getUserName()}
        </div>
      </>
    )
  }

  render() {
    const isMobile = window.innerWidth <= 440
    return (
      <div style={FixedHeader}>
        <div style={InnerContainer}>
          {isMobile ? this.renderMobileNav() : this.renderDesktopNav()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: Tgcc.GlobalState) => ({ state })

export const CatalogHeader = connect(mapStateToProps)(
  Radium(_CatalogHeader)
)
